import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Modal } from 'antd';
import moment from 'moment';
import CustomerWantsModal from '../Modals/CustomerWantsModal';

export default connect(state => ({
    customer_valuation: state.Leads.Lead_profile.Lead_valuations.customer_valuation,
    customer_valuation_date: state.Leads.Lead_profile.Lead_valuations.customer_valuation_date,
    selling_reason: state.Leads.Lead_profile.Lead_valuations.selling_reason,
}), null)(class CustomerWants extends Component {
  state = {
      visible: false,
  };

  openCustomerWantsModal = () => this.setState({ visible: true });

  closeModal = () => this.setState({ visible: false });

  componentWillUnmount() {
      this.props.dispatch({ type: 'RESET_CUSTOMER_VALUATION' });
  }

  render() {
      return (
          <div className="profile__information valuations" style={{ minHeight: 0 }}>
              <div className="profile__data valuation">
                  <h3 className="header" style={{ marginBottom: 0, marginRight: 0 }}>
                      Customer Expectations
                      <span
                          className="select_manually_wants"
                          onClick={this.openCustomerWantsModal}
                      >
                          <Icon type="edit" style={{ paddingRight: '5px' }} />
                          Change Price
                      </span>
                  </h3>
                  <p className="profile__contact">
                      {this.props.customer_valuation
                          ? (
                              <span style={{ width: '100%' }}>
                                  Сustomer wants £
                                  {this.props.customer_valuation}
                                  {' '}
                                  {this.props.customer_valuation_date && (
                                      <>
                                          (
                                          {new moment(this.props.customer_valuation_date).format('DD/MM/YYYY')}
                                          )
                                      </>
                                  )}
                                  {' '}
                                  for this bike
                                  {' '}
                                  {this.props.selling_reason && this.props.selling_reason.length > 0 && (
                                      <>
                                          because
                                          {this.props.selling_reason}
                                      </>
                                  )}
                              </span>
                          )
                          : (
                              <span style={{ fontStyle: 'italic', width: '100%' }}>
                                  Сustomer expectations for this bike are not specified
                              </span>
                          )
                      }
                  </p>
              </div>
              <Modal visible={this.state.visible} onCancel={this.closeModal} footer={null}>
                  <CustomerWantsModal closeModal={this.closeModal} />
              </Modal>
          </div>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/CustomerWants.js